var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPieChartAlt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 1.0625C11.6875 1.0625 11.3438 1.375 11.3438 1.78125V8.03125C11.3438 8.40625 11.6562 8.75 12.0625 8.75H18.75C18.9375 8.75 19.125 8.65625 19.25 8.53125C19.375 8.375 19.4375 8.1875 19.4375 8C19.1875 4.09375 15.9375 1.0625 12.0625 1.0625ZM12.75 7.28125V2.5C15.3437 2.8125 17.4375 4.75 17.9375 7.3125H12.75V7.28125Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0938 10.1564H10.125V3.43769C10.125 3.06269 9.8125 2.75019 9.4375 2.75019C9.34375 2.75019 9.25 2.75019 9.15625 2.75019C4.40625 2.71894 0.5625 6.59394 0.5625 11.3439C0.5625 16.0939 4.4375 19.9689 9.1875 19.9689C13.9375 19.9689 17.8125 16.0939 17.8125 11.3439C17.8125 11.1564 17.8125 10.9689 17.7812 10.8127C17.7812 10.4377 17.4688 10.1564 17.0938 10.1564ZM9.1875 18.5627C5.1875 18.5627 1.96875 15.3439 1.96875 11.3439C1.96875 7.53144 4.96875 4.37519 8.75 4.15644V10.8439C8.75 11.2189 9.0625 11.5627 9.46875 11.5627H16.4375C16.3125 15.4377 13.0938 18.5627 9.1875 18.5627Z",
    fill: "#6B7280"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPieChartAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pie-chart-alt.57d3ad28a82fad2f1f7138a5b89aec71.svg";